import Trans from "./Trans";

const BraveMeasureTextError = () => {
  return (
    <div data-testid="brave-measure-text-error">
      <p>
        <Trans
          i18nKey="errors.brave_measure_text_error.line1"
          bold={(el) => <span style={{ fontWeight: 600 }}>{el}</span>}
        />
      </p>
      <p>
        <Trans
          i18nKey="errors.brave_measure_text_error.line2"
          bold={(el) => <span style={{ fontWeight: 600 }}>{el}</span>}
        />
      </p>
      <p>
        <Trans
          i18nKey="errors.brave_measure_text_error.line3"
          // DRAWOLA:CUSTOM-START hide-upstream-links
          // Upstream links the excalidraw docs FAQ, issue tracker and Discord
          // here. drawOla owns none of them, so the words stay as plain text.
          link={(el) => <>{el}</>}
          // DRAWOLA:CUSTOM-END
        />
      </p>
      <p>
        <Trans
          i18nKey="errors.brave_measure_text_error.line4"
          // DRAWOLA:CUSTOM-START hide-upstream-links
          issueLink={(el) => <>{el}</>}
          discordLink={(el) => <>{el}.</>}
          // DRAWOLA:CUSTOM-END
        />
      </p>
    </div>
  );
};

export default BraveMeasureTextError;
